<div class="main-border-div">
  <header class="header-wrapper">
    <h5 class="head">Listings</h5>

    <div class="first-section">
      <!-- <div class="search-box">
        <img
          src="/assets/product_image/gray_search_icon.svg"
          class="me-2"
          alt=""
        />
        <input
          type="text"
          name="searchCustomer"
          (keyup)="onSearchKeyUp($event)"
          class="search-input-box"
          placeholder="Search..."
        />
      </div> -->
      <div class="btn-group dropstart">
        <button
          type="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
          class="secondary-btn btn me-3 d-flex gap-2 dropdown-toggle"
        >
          <img src="/assets/Icons/Filter_Icon.svg" alt="filter" />
          <span>Filter</span>
        </button>
        <div class="dropdown-menu filter-dropdown">
          <img
            class="d-flex ms-auto mt-2"
            (click)="resetFilter()"
            src="/assets/Icons/cross-icon.svg"
            alt=""
          />
          <div class="col">
            <label for="">Status</label>
            <select
              (change)="getMarketPlaceListings()"
              class="form-select form-select-lg"
              name="Status"
              #gender="ngModel"
              [(ngModel)]="statusFilter"
              aria-label="Large select example"
            >
              <option [ngValue]="0" selected hidden>Select</option>
              <option
                [ngValue]="status"
                *ngFor="let status of listingStatusList"
              >
                {{ status }}
              </option>
            </select>
          </div>
          <div class="col">
            <label for="">Marketplace</label>
            <select
              (change)="getMarketPlaceListings()"
              class="form-select form-select-lg"
              name="Marketplace"
              #gender="ngModel"
              [(ngModel)]="marketplaceFilter"
              aria-label="Large select example"
            >
              <option [ngValue]="0" selected hidden>Select</option>
              <option
                [ngValue]="marketplace.id"
                *ngFor="let marketplace of marketplaceList"
              >
                {{ marketplace.name }}
              </option>
            </select>
          </div>
          <div class="col">
            <label for="">Posting Profile</label>
            <select
              (change)="getMarketPlaceListings()"
              class="form-select form-select-lg"
              name="PostingProfile"
              #gender="ngModel"
              [(ngModel)]="postingProfileFilter"
              aria-label="Large select example"
            >
              <option [ngValue]="0" selected hidden>Select</option>
              <option
                [ngValue]="postingProfile.name"
                *ngFor="let postingProfile of postingProfileList"
              >
                {{ postingProfile.name }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </header>

  <div
    class="table-container"
    [ngClass]="{ 'full-height': productMarketplaceList.items.length }"
  >
    <table class="table">
      <thead class="main-head sticky-top" style="z-index: 2">
        <tr>
          <th class="col" style="width: 1%" scope="col"></th>
          <th class="col" style="width: 10%" scope="col">Title</th>
          <th class="col" style="width: 10%" scope="col">SKU</th>
          <th class="col" style="width: 10%" scope="col">Marketplace</th>
          <th class="col" style="width: 10%" scope="col">Account</th>
          <th class="col" style="width: 10%" scope="col">PostingProfile</th>
          <th class="col" style="width: 9%" scope="col">Type</th>
          <th class="col" style="width: 10%" scope="col">Listing Id</th>
          <th class="col" style="width: 10%" scope="col">Status</th>
          <th class="col" style="width: 10%" scope="col">Schedule At</th>
          <th class="col" style="width: 10%" scope="col">Expires At</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let listing of productMarketplaceList.items">
          <td class="col" style="width: 1%" scope="col"></td>
          <td class="col" style="width: 10%" scope="col">
            <div class="product">
              <img
                [src]=" listing?.product?.productImages?.[0]?.url
                    ?? '../../../../../assets/Icons/ic_demo_img.svg'
                "
                alt="Product Image"
              />
              <span>{{ listing.product.name }}</span>
            </div>
          </td>
          <td class="col" style="width: 10%" scope="col">
            {{ listing.product.sku }}
          </td>
          <td class="col" style="width: 10%" scope="col">
            {{ marketplaceEnumList[listing.marketplace - 1].name }}
          </td>
          <td class="col" style="width: 10%" scope="col">
            {{ listing.account }}
          </td>
          <td class="col" style="width: 10%" scope="col">
            {{ listing.postingProfile }}
          </td>
          <td class="col" style="width: 9%" scope="col">
            <div class="listing-type">
              <span>{{ listing.type }}</span>
              <div class="btn-group dropup">
                <img
                  class="dropdown-toggle"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  matTooltip="View Details" 
                  matTooltipPosition="above"
                  src="/assets/Icons/info-icon.svg"
                  alt=""
                />
                <ul
                  class="dropdown-menu rc-orders"
                  *ngIf="listing.type == 'BuyNow'"
                >
                  <li class="rc">
                    <label class="dropdown-item" href="#">Buy Now </label
                    ><span>{{ listing.buyNowPrice | currency }}</span>
                  </li>
                </ul>
                <ul
                  class="dropdown-menu rc-orders"
                  *ngIf="listing.type == 'Auction'"
                >
                  <li class="rc">
                    <label class="dropdown-item" href="#">Starting Bid</label
                    ><span>{{ listing.startingBid | currency }}</span>
                  </li>
                  <li class="rc">
                    <label class="dropdown-item" href="#">Reserved Price</label
                    ><span>{{ listing.reservePrice | currency }}</span>
                  </li>
                  <li class="rc">
                    <label class="dropdown-item" href="#">Bid Increment</label
                    ><span>{{ listing.bidIncrement | currency }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </td>
          <td class="col" style="width: 10%" scope="col">
            {{ listing.listingId }}
          </td>
          <td class="col" style="width: 10%" scope="col">
            <span>
              <span
                class="text-primary"
                [appCustomTooltip]="listing.failedReason"
              >
                {{ listing.status }}
              </span>
            </span>
          </td>
          <td class="col" style="width: 10%" scope="col">
            {{ listing.scheduleAt | date : "dd/MM/YY h:mm a" }}
          </td>
          <td class="col" style="width: 10%" scope="col">
            {{ listing.expireAt | date : "dd/MM/YY h:mm a" }}
          </td>
        </tr>
      </tbody>
    </table>
    <div
      class="w-100 h-100"
      *ngIf="productMarketplaceList.items.length === 0"
      style="
        color: #a4a4a4;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 34px;
        padding-bottom: 50px;
      "
    >
      No Data Available
    </div>
  </div>
  <app-pagination
    *ngIf="productMarketplaceList.items.length"
    [currentPage]="currentPage"
    [totalPages]="totalPages"
    [totalRecords]="totalRecords"
    [itemsPerPage]="itemsPerPage"
    [pageSizes]="pageSizes"
    [pagesToShow]="pagesToShow"
    (pageChange)="onPageChange($event)"
    (itemsPerPageChange)="onItemsPerPageChange($event)"
  >
  </app-pagination>
</div>
